import React from "react"

export default function Header() {
  return <div className='font-family-bungee flex p-1 text-2xl w-screen fixed top-0 bg-gray-600 text-gray-100 shadow-2xl z-40 md:text-sm'>
    <a href="#ABOUT"><p className='m-4 hover:text-yellow-200 hvr-bounce-in'>ABOUT</p></a>
    <a href="#SKILL"><p className='m-4 hover:text-yellow-200 hvr-bounce-in'>SKILL</p></a>
    <a href="#PROJECTS"><p className='m-4 hover:text-yellow-200 hvr-bounce-in'>PROJECTS</p></a>
    <a href="#CONTACT"><p className='m-4 hover:text-yellow-200 hvr-bounce-in'>CONTACT</p></a>
  </div>
}
